import React, { useState,useEffect } from "react";
import { uiActions, visualizerActions } from "../../store";
import { useDispatch, useSelector } from "react-redux";


import PopUpModal from "../PopUpModal/PopUpModal";
import FormInput from "../FormInput/FormInput";
import FormTextarea from "../FormTextarea/FormTextarea";

import styles from "./EmailShare.module.css";

import emailIcon from './assets/email.svg';

import { generateShareLink } from "../../Helpers/ShareHelper";

// Email pop up form
export default function EmailShareModal() {

    const dispatch = useDispatch();

    const [formValidity, setFormValidity] = useState({});

    const shareData = useSelector((state) => state.visualizer.shareData);

    const message = 
`Check out a flooring design I created using Tarkett's Contour® and Victory® LVT Studio. You can explore the layout, color, and pattern options using this interactive online visualizer.

Feel free to explore, modify, or start your own design from here!
`;

    const [defaultMessage, setDefaultMessage] = useState(message + "\n" + "(Link loading...)");


    useEffect(() => {
        if (!shareData.url) {
            setDefaultMessage(message + "\n(Link loading...)");
        } else {
            setDefaultMessage(message + "\n" + shareData.url);
        }
    }, [shareData]);


    useEffect(() => {
        if (!shareData.url) {
            generateShareLink().then(result => {
                dispatch(visualizerActions.setShareData(result));
            });
        }
    }, []);

    const checkFormValidity = function() {
        for(let key in formValidity){
            if(!formValidity[key]){
                document.getElementById(key).focus();
                document.getElementById(key).blur();
                return false;
            }
        }

        return true;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(checkFormValidity()){
            const data = new FormData(event.target);
            const dataObj = data.entries();
            const formData = {};
            dataObj.forEach((arry, key) => {
                formData[arry[0]] = arry[1]
            });

            var emailData = {
                "fromName":formData["Your Name"],
                "fromEmail":formData["Your Email"],
                "toName":formData["Friend's Name"],
                "toEmail":formData["Friend's Email"],
                "body":formData["Add your message"],
            }

            try {
                const response = await fetch('/services/email.ashx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams(emailData).toString() 
                });

                if (response.ok) {
                    // Handle success
                    console.log('Form submitted successfully');
                    handleClose();
                } else {
                    // Handle error
                    console.error('Form submission failed');
                }
            } catch (error) {
                console.error('Error submitting form:', error);
            }
        }

        // if(checkFormValidity()){
        //     const data = new FormData(event.target);
        //     const dataObj = data.entries();
        //     const formData = {};
        //     dataObj.forEach((arry, key) => {
        //         formData[arry[0]] = arry[1]
        //     });

        //     try {

        //         let url = `/services/email.ashx?fromName=${formData["Your Name"]}&fromEmail=${formData["Your Email"]}&toName=${formData["Friend's Name"]}&toEmail=${formData["Friend's Email"]}&body=${formData["Add your message"]}`;

        //         const response = await fetch(url, {
        //             method: 'GET',
        //         });

        //         if (response.ok) {
        //             // Handle success
        //             console.log('Form submitted successfully');
        //             handleClose();
        //         } else {
        //             // Handle error
        //             console.error('Form submission failed');
        //         }
        //     } catch (error) {
        //         console.error('Error submitting form:', error);
        //     }
        // }
    };

    const handleClose = () => {
        dispatch(uiActions.setEmailModalActive(false));
        dispatch(uiActions.setShareModalActive(true));
    };
    return (
            <>
                    <PopUpModal handleClose={handleClose}>
                        <div className={styles.container}>
                        <h1>Share via Email</h1>
                        <form onSubmit={handleSubmit}>

                            <FormInput
                                label="Your Name"
                                type="text" 
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/^[A-Za-z\s]+$/}
                                setFormValidity={setFormValidity}/>

                            <FormInput
                                label="Your Email"
                                type="email" 
                                required={true}
                                errorMsg={"Enter valid email address. ex - someone@example.com"}
                                pattern={/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/}
                                setFormValidity={setFormValidity} />

                            <FormInput
                                label="Friend's Name"
                                type="text" 
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/^[A-Za-z\s]+$/}
                                setFormValidity={setFormValidity}/>

                            <FormInput
                                label="Friend's Email"
                                type="email" 
                                required={true}
                                errorMsg={"Enter valid email address. ex - someone@example.com"}
                                pattern={/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/} 
                                setFormValidity={setFormValidity}/>

                            <FormTextarea
                                label="Add your message"
                                defaultText={defaultMessage}
                                required={true} 
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/.*/}
                                setFormValidity={setFormValidity}/>

                            <button type="submit">Send</button>
                        </form>
                        </div>
                    </PopUpModal>
            </>
        );
}


// Email share button
const EmailShareLink = () => {
    const dispatch = useDispatch();

    const handleClick = function() {
        dispatch(uiActions.setShareModalActive(false));
        dispatch(uiActions.setEmailModalActive(true));
    }

    return (
        <button className={styles.shareEmailBtn} onClick={handleClick} aria-label="Open Share Modal">
           <img src={emailIcon} className={styles.emailSvg} alt="open share modal icon"/>
        </button>
    );
};

export {EmailShareModal, EmailShareLink} 

